<template>
  <div class="header-box">
    <!-- <div class="notice" v-if="isNotice">
      <i class="icon icon-close-notice" @click="hiddNotice"></i>

      <div class="notice-content flex-center">
        <h6 class="h6-mini">
          {{ $t("layout.header.notice.text") }}
        </h6>
        <div class="view-more-but">
          <ButtonCommon
            type="transferMin"
            width="120px"
            height="32px"
            @click="toViewMore"
            ><h6 class="h6-mini">{{ $t("layout.header.notice.viewMore") }}</h6>
          </ButtonCommon>
        </div>
      </div>
    </div> -->

    <header class="container">
      <div class="header flex-space-between">
        <div class="header-logo flex-align-center">
          <a
            class="a-link flex-align-center"
            href="https://marginx.io"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i class="icon icon-logo" />
            <i class="icon icon-logo-font" />
          </a>
          <div v-if="isEnv" class="header-v">
            <p>{{ $t("layout.header.testnet") }}</p>
          </div>
          <div class="header-nav flex-align-center">
            <ul class="flex-align-center header-nav-ul">
              <li :class="{ active: $route.meta.name === 'Home' }">
                <router-link to="/">
                  <strong>{{ $t("layout.header.nav.markets") }}</strong>
                </router-link>
              </li>
              <li>
                <a
                  :href="liquidityPoolUrl"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i class="icon icon-nav_arrow"></i>
                  <strong>{{ $t("layout.header.nav.liquidityPool") }}</strong>
                </a>
              </li>
              <li>
                <a
                  :href="fxbridgeUrl"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i class="icon icon-nav_arrow"></i>
                  <strong>{{ $t("layout.header.nav.bridge") }}</strong>
                </a>
              </li>

              <!-- <li :class="{ active: $route.meta.name === 'Bridge' }">
                <router-link :to="`/bridge${getInviteCode}`">
                  <strong>{{ $t("layout.header.nav.bridge") }}</strong>
                </router-link>
              </li> -->
              <!-- <li :class="{ active: $route.meta.name === 'Rewards' }">
                <router-link to="/rewards">
                  <strong>{{ $t("layout.header.nav.rewards") }}</strong>
                </router-link>
              </li>
              <li :class="{ active: $route.meta.name === 'Dashboard' }">
                <router-link to="/dashboard">
                  <strong>{{ $t("layout.header.nav.dashboard") }}</strong>
                </router-link>
              </li>
              <li :class="{ active: $route.meta.name === 'Referral' }">
                <router-link to="/referral">
                  <strong>{{ $t("layout.header.nav.referral") }}</strong>
                </router-link>
              </li> -->
              <li>
                <a
                  :href="starScanUrl"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i class="icon icon-nav_arrow"></i>
                  <strong>{{ $t("layout.header.nav.starScan") }}</strong>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="header-nav flex-align-center">
          <!-- <div class="header-nav-ul header-my-assets" v-if="getUser.address">
            <li :class="{ active: $route.meta.name === 'MyAssets' }">
              <router-link to="/myAssets">
                <strong>{{ $t("layout.header.nav.myAssets") }}</strong>
              </router-link>
            </li>
          </div> -->
          <div class="header-connect-wallet">
            <ConnectWallet class="connect-wallet-but"> </ConnectWallet>
          </div>
          <div class="flex-align-center header-more-information">
            <div class="nav-menu-normal">
              <div class="menu-normal">
                <div class="menu-normal-1"></div>
                <div class="menu-normal-2"></div>
                <div class="menu-normal-3"></div>
              </div>
              <ul>
                <a
                  v-for="m in moreInformationEnvListComputed"
                  :key="m.value"
                  :href="m.url"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <li class="more-information-li">
                    <i :class="['icon', m.iconName]"></i
                    ><strong>{{ m.text }}</strong>
                  </li>
                </a>
                <a
                  v-for="m in moreInformationListComputed"
                  :key="m.value"
                  :href="m.url"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <li class="more-information-li">
                    <i :class="['icon', m.iconName]"></i
                    ><strong>{{ m.text }}</strong>
                  </li>
                </a>
              </ul>
            </div>
            <div class="nav-menu-down-h-3x">
              <i class="icon icon-down-nav"></i>
              <div class="down-box flex-align-center">
                <div class="qr-img">
                  <img class="qrimg" :src="qrImg" alt="" />
                </div>
                <div class="down-text">
                  <h6>{{ $t("layout.header.download.downloadfxWallet") }}</h6>

                  <p>
                    {{ $t("layout.header.download.downloadfxWalletPlease") }}
                  </p>
                </div>
              </div>
            </div>
            <div class="nav-menu-qkyy">
              <i class="icon icon-qkyy"></i>
              <ul>
                <li
                  @click="switchLang(l.value)"
                  :class="[
                    'more-information-li',
                    { active: l.value === $i18n.locale },
                  ]"
                  v-for="(l, index) in languageList"
                  :key="index"
                >
                  <strong>{{ l.text }}</strong>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </header>
  </div>
</template>
<script>
import ConnectWallet from "@/components/Common/connectWallet.vue";
// import ButtonCommon from "@/components/Common/button";
import { mapGetters } from "vuex";
import QRCode from "qrcode";
export default {
  name: "Header",
  data() {
    return {
      isNotice: true,
      qrImg: "",
      isMoreInformation: true,
      moreInformationEnvList: [
        {
          text: this.$t("layout.header.moreInformationEnvList.prod"),
          value: "prod",
          iconName: "icon-menu-mainnet",
          url: "https://trade.marginx.io",
        },
        {
          text: this.$t("layout.header.moreInformationEnvList.testnet"),
          value: "testnet",
          iconName: "icon-menu-testnet",
          url: "https://demo.marginx.io",
        },
      ],
      moreInformationList: [
        // {
        //   text: "Discord",
        //   value: "discord",
        //   iconName: "icon-discord",
        //   url: "https://discord.com/invite/7yUjqadZFq",
        // },
        // {
        //   text: this.$t("layout.header.moreInformationList.blog"),
        //   value: "blog",
        //   iconName: "icon-blog",
        //   url: "https://linktr.ee/marginx",
        // },
        {
          text: this.$t("layout.header.moreInformationEnvList.links"),
          value: "Links",
          iconName: "icon-blog",
          url: "https://linktr.ee/marginx",
        },
        // {
        //   text: this.$t("layout.header.moreInformationList.testChain"),
        //   value: "faucet",
        //   iconName: "icon-test-chain",
        //   url: "https://testnet-faucet.functionx.io",
        // },
      ],
      languageList: [
        {
          text: this.$t("layout.header.languageList.english"),
          value: "en",
        },
        {
          text: this.$t("v4.2.layout.header.languageList.korean"),
          value: "kr",
        },
        {
          text: this.$t("v4.2.layout.header.languageList.indonesian"),
          value: "id",
        },
      ],
      language: this.getStorage("Language"),
    };
  },
  components: { ConnectWallet },
  computed: {
    ...mapGetters(["getUser"]),

    moreInformationEnvListComputed() {
      return this.moreInformationEnvList.filter(
        (elem) => elem.value !== process.env.VUE_APP_REWARD_NNETWORK
      );
    },

    moreInformationListComputed() {
      const arr = [];
      this.moreInformationList.forEach((elem) => {
        if (process.env.VUE_APP_REWARD_NNETWORK !== "prod") {
          arr.push(elem);
        } else {
          if (elem.value !== "faucet") {
            arr.push(elem);
          }
        }
      });

      return arr;
    },

    starScanUrl() {
      return process.env.VUE_APP_BROWSER;
    },
    fxbridgeUrl() {
      return process.env.VUE_APP_BROWSER + "fxbridge";
    },
    liquidityPoolUrl() {
      return process.env.VUE_APP_ALO_URL;
    },
    isEnv() {
      return process.env.VUE_APP_REWARD_NNETWORK !== "prod";
    },

    getInviteCode() {
      return this.$route.query.InviteCode
        ? `/?InviteCode=${this.$route.query.InviteCode}`
        : "";
    },
  },
  methods: {
    setStorage(key, data) {
      window.localStorage.setItem(key, data);
    },
    getStorage(key) {
      const str = window.localStorage.getItem(key);
      return !str ? "en" : str;
    },
    switchLang(val) {
      this.$i18n.locale = val;
      this.setLanguage(val);
    },
    setLanguage(val) {
      this.language = val;
      this.setStorage("Language", val);
      window.location.reload();
    },
    hiddNotice() {
      this.isNotice = false;
    },
    toViewMore() {
      const viewmore = process.env.VUE_APP_OPTIONS + "/activity";
      window.open(viewmore, "_blank", "noopener,noreferrer");
    },
    async getDownloadQR() {
      try {
        const download = process.env.VUE_APP_DOWNLOAD;
        this.qrImg = await QRCode.toDataURL(download, {
          errorCorrectionLevel: "L",
          margin: 0,
        });
      } catch (err) {
        console.error("Generate QR code fail: ", err);
      }
    },
  },
  created() {
    this.getDownloadQR();
  },
};
</script>
<style lang="scss" scoped>
$marginLeft40: 40px;

.header-box {
  position: sticky;
  top: 0;
  z-index: 2001;
  left: 0;
  width: 100%;
  .normal-main {
    height: 2px;
    background-color: rgb(255 255 255 / 80%);
    border-radius: 2px;
    transition: backgroundColor ease $transition-all-time,
      width ease $transition-all-time;
  }

  .notice {
    position: relative;
    background-image: linear-gradient(180deg, #d2fb31 0%, #a6f616 100%);
    height: 48px;
    width: 100%;

    .icon-close-notice {
      cursor: pointer;
      position: absolute;
      right: 14px;
      top: 50%;
      transform: translate(0%, -50%);
    }

    .notice-content {
      h6 {
        color: #101314;
        text-align: center;
        line-height: 48px;
      }

      .view-more-but {
        margin-left: 20px;
      }
    }
  }
  header {
    background: #101314;
    height: 48px;
    // margin-bottom: 4px;

    .header {
      height: 100%;
      padding: 0 24px;

      .a-link {
        text-decoration: none;
      }
    }

    .header-name {
      margin-top: 4px;
    }

    .header-connect-wallet {
      height: 100%;
      border-left: 1px solid rgba(255, 255, 255, 0.08);
      border-right: 1px solid rgba(255, 255, 255, 0.08);
      padding-left: 24px;
      padding-right: 24px;
      align-items: center;
      display: flex;

      .connect-wallet-but {
        min-width: 160px;
      }
    }

    .header-more-information {
      cursor: pointer;
      z-index: 999;

      ul {
        display: none;
        font-style: normal;
        box-sizing: border-box;
        width: 240px;
        position: absolute;
        top: 38px;
        left: -120px;
        border-radius: 12px;
        overflow: hidden;
        background: #2a2c32;
        padding: 12px;
        box-sizing: border-box;
        box-shadow: rgb(0 0 0 / 30%) 0px 10px 20px,
          rgb(255 255 255 / 40%) 0px 0px 1px inset;

        a {
          display: block;
          width: 100%;
          height: 100%;
          text-decoration: none;

          &:last-child {
            li {
              margin-bottom: 0px;
            }
          }
        }

        li {
          position: relative;
          padding: 16px 16px;
          display: flex;
          align-items: center;
          background: #1e1f23;
          border-radius: 8px;
          margin-bottom: 12px;

          .icon {
            width: 20px;
            height: 20px;
            margin-right: 12px;
            pointer-events: none;
          }
          strong {
            pointer-events: none;
            color: #fff;
            opacity: 0.8;
          }

          &::before {
            display: inline-block;
            background-size: cover;
            background-repeat: no-repeat;
            background-position: center;
            position: absolute;
            background-image: url("../../assets/images/assets/arrow.svg");
          }

          &:hover {
            background: #101112;
            &::before {
              content: "";
              width: 18px;
              height: 24px;
              right: 18px;
              animation: iconArrow 0.6s ease;
            }

            strong {
              opacity: 1;
            }
          }
        }
      }

      .nav-menu-qkyy,
      .nav-menu-normal {
        margin-left: 24px;
        position: relative;

        .menu-normal {
          .menu-normal-1 {
            width: 12px;
            margin-bottom: 4px;
            @extend .normal-main;
          }
          .menu-normal-2 {
            width: 20px;
            @extend .normal-main;
          }
          .menu-normal-3 {
            width: 16px;
            margin-top: 4px;
            @extend .normal-main;
          }
        }

        &:hover {
          .menu-normal-1,
          .menu-normal-3 {
            width: 20px;
          }
          .menu-normal-1,
          .menu-normal-2,
          .menu-normal-3 {
            background-color: rgb(255 255 255 / 100%);
          }

          &::before {
            content: "";
            position: absolute;
            width: 200px;
            height: 29px;
            top: 10px;
            right: -85px;
          }

          ul {
            display: block;
          }
        }
      }
      .nav-menu-qkyy {
        &:hover {
          &::before {
            content: "";
            position: absolute;
            width: 160px;
            height: 29px;
            top: 18px;
            right: -24px;
          }
        }
        ul {
          width: 160px;
          position: absolute;
          top: 38px;
          left: auto;
          right: -24px;

          li {
            &.active {
              border: 0.5px solid rgba(166, 246, 22, 1);
              background: #101112;
            }
            &:first-child {
              margin-bottom: 12px;
            }

            &:hover {
              &::before {
                content: none;
              }
            }
          }
        }
      }

      .nav-menu-qkyy,
      .nav-menu-down-h-3x {
        position: relative;
        margin-left: 36px;
        display: flex;
        align-items: center;

        .down-box {
          display: none;
          position: absolute;
          top: 38px;
          right: -72px;
          width: 360px;
          padding: 24px;
          box-sizing: border-box;
          background: #2a2c32;
          border: 0.5px solid rgba(255, 255, 255, 0.16);
          box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.5);
          border-radius: 8px;

          .down-text {
            h6 {
              line-height: 18px;
              margin-bottom: 12px;
              font-size: 18px;
              background-image: linear-gradient(
                90deg,
                #1d97c7 0%,
                #875ff3 100% 100%
              );
              -webkit-background-clip: text;
              color: transparent;
            }
            p {
              font-size: 14px;
              color: #ffffff;
              line-height: 20px;
              font-weight: 400;
            }
          }

          .qr-img {
            background: #ffffff;
            border-radius: 4px;
            padding: 3px;
            width: 80px;
            height: 80px;
            margin-right: 24px;
            .qrimg {
              width: 80px;
              height: 80px;
            }
          }
        }

        &:hover {
          .down-box {
            display: flex;
          }
        }
      }
    }

    .header-logo {
      height: 100%;
      color: $lighten-color;
      .icon-logo {
        margin-right: 8px;
      }
      .header-v {
        margin-left: 8px;
        width: 71px;
        height: 22px;
        line-height: 22px;
        background: #2a2c32;
        border-radius: 11px;
        text-align: center;
        font-size: 14px;
        font-weight: 400;
      }
      .header-split {
        width: 24px;
        height: 16px;
        border-right: 1px solid rgba($color: #fff, $alpha: 0.2);
      }
      .header-language {
        img {
          width: 16px;
          height: 16px;
          vertical-align: middle;
        }
        cursor: pointer;
        margin-left: 24px;
        color: $lighten-color;
        opacity: 0.5;
        strong {
          margin: 0 8px;
        }
        .arrow-down {
          border-left: 4px solid transparent;
          border-right: 4px solid transparent;
          border-top: 4px solid rgba($color: #fff, $alpha: 0.5);
        }
        &.active {
          opacity: 1;
        }

        &:hover {
          opacity: 0.8;
        }
      }
    }

    .header-nav {
      height: 100%;

      .header-button {
        margin-left: $marginLeft40;
      }

      .header-my-assets {
        margin-left: 24px;
        margin-right: 24px;
      }

      .header-nav-ul,
      .header-my-assets {
        a {
          display: flex;
          align-items: center;
          width: 100%;
          height: 100%;
          text-decoration: none;
          color: rgb(255 255 255 / 80%);
        }
        li {
          position: relative;
          cursor: pointer;
          box-sizing: border-box;
          height: 100%;
          line-height: 48px;
          margin-left: $marginLeft40;

          @media screen and (max-width: 1581px) {
            margin-left: 24px;
          }

          strong {
            color: rgb(255 255 255 / 80%);
          }
          &.active {
            a {
              pointer-events: none;
            }

            strong {
              -webkit-background-clip: text;
              color: transparent;
              background-image: linear-gradient(
                90deg,
                #18eed8 0%,
                #a6f616 100%
              );
            }

            &::before {
              content: "";
              position: absolute;
              bottom: 0;
              left: 6px;
              right: 6px;
              height: 2px;
              border-radius: 1px;
              background-image: linear-gradient(
                90deg,
                #18eed8 1%,
                #a6f616 100%
              );
            }
          }

          &:hover {
            &:not(&.active) {
              strong {
                color: #fff;
              }
            }
          }
        }
        .gradient {
          img {
            width: 14px;
            height: 14px;
            vertical-align: middle;
          }
          strong {
            margin-left: 4px;
            background-image: linear-gradient(90deg, #18eed8 1%, #a6f616 100%);
            -webkit-background-clip: text;
            color: transparent;
          }
        }
      }
    }
  }
}
@keyframes iconArrow {
  30% {
    right: 6px;
  }
  80% {
    right: 14px;
  }
}
</style>
<style lang="scss">
.header-connect-wallet {
  .connect-wallet-but {
    .button-common .marginXBridge {
      padding-left: 16px;
      padding-right: 16px;
    }
  }
}
</style>
